import PropTypes from 'prop-types'
import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { getBalance } from 'models/ProfileInfo/selectors'
import { POPULAR_CATEGORY } from 'models/Rewards/constants'
import { getRewards } from 'models/Rewards/selectors'
import getDecimalValue from 'utils/get-decimal-value'

import RewardProductItem from '../RewardProductItem'
import RewardsCategoryHeader from './RewardsCategoryHeader'

const RewardsCategoryDetails = ({ selectedCategory }) => {
  const balance = useSelector(getBalance)
  const rewards = useSelector(getRewards)

  const filteredProducts = useMemo(() => {
    if (selectedCategory?.id === POPULAR_CATEGORY) {
      return rewards.filter((reward) => reward?.isTop)
    }
    return rewards.filter((reward) => reward?.categoryId === selectedCategory?.id)
  }, [rewards, selectedCategory?.id])

  return (
    <>
      <RewardsCategoryHeader categoryName={selectedCategory?.name} />
      {filteredProducts.map((item) => {
        let isDisabled = false
        if (getDecimalValue(item.redemptionValues[0]).gt(balance)) {
          isDisabled = true
        }
        return <RewardProductItem key={item.id} product={item} isDisabled={isDisabled} />
      })}
    </>
  )
}

RewardsCategoryDetails.propTypes = {
  selectedCategory: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    iconUrl: PropTypes.string.isRequired,
    description: PropTypes.string,
  }).isRequired,
}

export default RewardsCategoryDetails
